import { Component } from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import FormData from "form-data"
import displayFlash from "partners/scripts/display_flash"
import classNames from "classnames"

export default class ImageUploader extends Component {
  constructor(props) {
    super(props)
    this.onDrop = this.onDrop.bind(this)
    this.state = {
      currentImage: this.props.current_image,
    }
    this.isOnColor =
      this.props.color_style == "on_color" ||
      this.props.color_style == "monochrome"
  }

  onDrop(file) {
    const fd = new FormData()

    let onColor = this.props.color_style
    if (onColor == "default") {
      fd.append("on_color", "false")
    } else if (onColor == "on_color") {
      fd.append("on_color", "true")
    } else {
      fd.append("on_color", onColor)
    }
    fd.append("icon", file[0])
    fd.append("authenticity_token", this.props.authenticity_token)
    fd.append("field", this.props.field)

    displayFlash("Uploading service icon…")

    fetch(
      new Request(`/services/${this.props.service_slug}/icon`, {
        method: "POST",
        cache: "no-store",
        body: fd,
      })
    )
      .then(response => {
        if (!response.ok) {
          response.text().then(body => eval(body))
        } else {
          readURL(
            file,
            `div[data-image-type=${this.props.color_style}] img`,
            this.props.preview_target
          )
        }
      })
      .catch(() => {
        displayFlash("There has been an error. Please try again!", "error")
      })
  }

  setStyle() {
    if (this.isOnColor && this.props.brand_color) {
      return {
        backgroundColor: `#${this.props.brand_color}`,
        borderColor: `#${this.props.brand_color}`,
      }
    } else {
      return {}
    }
  }

  renderImageAndUploadButton() {
    return (
      <div className="content">
        {this.state.currentImage && (
          <div className="button">
            <img src={this.state.currentImage} width="310" />
          </div>
        )}
        <p className="note">
          <span
            className={classNames("button-tertiary", {
              "button-on-color": this.isOnColor,
            })}
          >
            Upload a new file
          </span>
        </p>
      </div>
    )
  }

  render() {
    return (
      <div
        className="dropzone-container"
        multiple={false}
        accept={"image/svg+xml"}
      >
        <Dropzone
          onDrop={this.onDrop}
          className={`dropzone ${this.props.color_style}`}
          style={this.setStyle()}
        >
          {this.renderImageAndUploadButton()}
        </Dropzone>
      </div>
    )
  }
}

function readURL(input, target, previewTarget) {
  if (input[0]) {
    const reader = new FileReader()
    reader.onload = e => {
      document.querySelector(target).src = e.target.result
      if (previewTarget.length) {
        document
          .querySelectorAll(previewTarget)
          .forEach(preview => (preview.src = e.target.result))
      }
    }

    reader.readAsDataURL(input[0])
  }
}

ImageUploader.propTypes = {
  current_image: PropTypes.string,
  color_style: PropTypes.string,
  service_slug: PropTypes.string.isRequired,
  authenticity_token: PropTypes.string.isRequired,
  brand_color: PropTypes.string,
  dimensions_message: PropTypes.string,
  preview_target: PropTypes.array,
  field: PropTypes.string,
}

ImageUploader.defaultProps = {
  preview_target: [],
}
